<gatewee-drawer
  *ngIf="usePageDrawer"
  [open]="pageDrawerOpen"
  (openChange)="onPageDrawerOpenChange($event)"
  [showHeaderTitle]="true"
  [title]="drawerEmbeddedTitleKey | translate"
  [showBackButton]="activeFlow !== 'hub'"
  [backButtonLabel]="'common.actions.back' | translate"
  (backClick)="handleShellBack()"
  [closeButtonLabel]="'common.close' | translate"
>
  <ng-container *ngTemplateOutlet="pixShell"></ng-container>
  <footer *ngIf="activeFlow === 'transfer'">
    <ng-container *ngIf="transferForm?.actionFooterTpl as footTpl">
      <ng-container *ngTemplateOutlet="footTpl"></ng-container>
    </ng-container>
  </footer>
  <footer *ngIf="activeFlow === 'emv'">
    <ng-container *ngIf="emvForm?.actionFooterTpl as emvFootTpl">
      <ng-container *ngTemplateOutlet="emvFootTpl"></ng-container>
    </ng-container>
  </footer>
</gatewee-drawer>

<ng-container *ngIf="!usePageDrawer">
  <ng-container *ngTemplateOutlet="pixShell"></ng-container>
</ng-container>

<ng-template #pixShell>
  <div
    class="gw-overflow-hidden"
    [class.gw-flex]="usePageDrawer"
    [class.gw-h-full]="usePageDrawer"
    [class.gw-min-h-0]="usePageDrawer"
    [class.gw-flex-col]="usePageDrawer"
    [class.gw-rounded-2xl]="!usePageDrawer"
    [class.gw-shadow-lg]="!usePageDrawer"
  >
    <div
      *ngIf="!usePageDrawer && activeFlow !== 'hub'"
      class="gw-flex gw-items-center gw-gap-small gw-p-medium gw-border-b gw-border-border-normal gw-shrink-0"
    >
      <button
        type="button"
        class="gw-flex gw-h-10 gw-w-10 gw-shrink-0 gw-items-center gw-justify-center gw-rounded-full gw-border-0 gw-bg-transparent gw-cursor-pointer hover:gw-bg-background-neutral-1-hover"
        [attr.aria-label]="'common.actions.back' | translate"
        (click)="handleShellBack()"
      >
        <gatewee-icon
          icon="@phi.caret-left"
          iconStyle="primary"
          size="20px"
        ></gatewee-icon>
      </button>
      <h2
        class="gw-text-lg gw-font-semibold gw-text-text-primary gw-m-0 gw-min-w-0 gw-flex-1 gw-truncate"
      >
        {{ drawerEmbeddedTitleKey | translate }}
      </h2>
    </div>

    <div
      class="gw-w-full pix-step-viewport pix-step-stack"
      [class.gw-min-h-0]="usePageDrawer"
      [class.gw-flex-1]="usePageDrawer"
      [class.gw-flex]="usePageDrawer"
      [class.gw-flex-col]="usePageDrawer"
    >
      <div
        class="gw-min-w-0 gw-box-border pix-step-pane"
        [class.pix-step-pane--visible]="activeFlow === 'hub'"
      >
        <div
          *ngIf="!usePageDrawer && activeFlow === 'hub'"
          class="gw-flex gw-justify-between gw-items-center gw-p-medium gw-border-b gw-border-border-normal"
        >
          <h2
            class="gw-text-lg gw-font-semibold gw-text-text-primary gw-m-0 gw-flex gw-items-center gw-gap-small"
          >
            <gatewee-icon
              icon="@tui.credit-card"
              class="gw-text-primary"
            ></gatewee-icon>
            {{ 'features.withdrawals.modalPix.title' | translate }}
          </h2>
        </div>

        <div class="gw-mb-0 gw-mt-[4px]">
          <div class="gw-flex gw-justify-between">
            <button
              type="button"
              class="gw-max-w-full gw-w-[100px] gw-flex gw-flex-col gw-items-center gw-text-center gw-gap-[26px] gw-cursor-pointer"
              (click)="openTransfer()"
            >
              <div
                class="gw-flex gw-h-[52px] gw-w-[52px] gw-shrink-0 gw-items-center gw-justify-center gw-bg-background-elevation-3 gw-rounded-[100px] gw-shadow-md hover:gw-bg-background-neutral-1-hover"
              >
                <gatewee-icon
                  icon="@phi.arrows-down-up"
                  size="24px"
                  iconStyle="primary"
                ></gatewee-icon>
              </div>
              {{
                'features.withdrawals.modalPix.pixAreaActions.transfer'
                  | translate
              }}
            </button>
            <button
              type="button"
              class="gw-max-w-full gw-w-[100px] gw-flex gw-flex-col gw-items-center gw-text-center gw-gap-[26px] gw-cursor-pointer"
              (click)="navigateTo('/panel/invoices/new')"
            >
              <div
                class="gw-flex gw-h-[52px] gw-w-[52px] gw-shrink-0 gw-items-center gw-justify-center gw-bg-background-elevation-3 gw-rounded-[100px] gw-shadow-md hover:gw-bg-background-neutral-1-hover"
              >
                <gatewee-icon
                  icon="@phi.currency-circle-dollar"
                  size="24px"
                  iconStyle="primary"
                ></gatewee-icon>
              </div>
              {{
                'features.withdrawals.modalPix.pixAreaActions.charge'
                  | translate
              }}
            </button>
          </div>
          <div class="gw-flex gw-mt-x-large gw-justify-between">
            <button
              type="button"
              class="gw-max-w-full gw-w-[100px] gw-flex gw-flex-col gw-items-center gw-text-center gw-gap-[26px] gw-cursor-pointer"
              (click)="openEmv()"
            >
              <div
                class="gw-flex gw-h-[52px] gw-w-[52px] gw-shrink-0 gw-items-center gw-justify-center gw-bg-background-elevation-3 gw-rounded-[100px] gw-shadow-md hover:gw-bg-background-neutral-1-hover"
              >
                <gatewee-icon
                  icon="@phi.files"
                  size="24px"
                  iconStyle="primary"
                ></gatewee-icon>
              </div>
              {{
                'features.withdrawals.modalPix.pixAreaActions.pixCopyPaste'
                  | translate
              }}
            </button>
            <button
              type="button"
              class="gw-max-w-full gw-w-[100px] gw-flex gw-flex-col gw-items-center gw-text-center gw-gap-[26px] gw-cursor-pointer"
              (click)="openQrScanner()"
            >
              <div
                class="gw-flex gw-h-[52px] gw-w-[52px] gw-shrink-0 gw-items-center gw-justify-center gw-bg-background-elevation-3 gw-rounded-[100px] gw-shadow-md hover:gw-bg-background-neutral-1-hover"
              >
                <gatewee-icon
                  icon="@phi.qr-code"
                  size="24px"
                  iconStyle="primary"
                ></gatewee-icon>
              </div>
              {{
                'features.withdrawals.modalPix.pixAreaActions.payQrCode'
                  | translate
              }}
            </button>
            <button
              type="button"
              class="gw-max-w-full gw-w-[100px] gw-flex gw-flex-col gw-items-center gw-text-center gw-gap-[26px] gw-opacity-40 gw-pointer-events-none gw-cursor-not-allowed"
              disabled
            >
              <div
                class="gw-flex gw-h-[52px] gw-w-[52px] gw-shrink-0 gw-items-center gw-justify-center gw-bg-background-elevation-3 gw-rounded-[100px] gw-shadow-md"
              >
                <gatewee-icon
                  icon="@phi.money"
                  size="24px"
                  iconStyle="primary"
                ></gatewee-icon>
              </div>
              {{
                'features.withdrawals.modalPix.pixAreaActions.deposit'
                  | translate
              }}
            </button>
          </div>
        </div>

        <section
          *ngIf="recipientLimits"
          class="gw-mt-x-large border-pix gw-pt-x-large"
          [attr.aria-label]="
            'features.withdrawals.modalPix.limits.sectionTitle' | translate
          "
        >
          <h3
            class="gw-m-0 gw-mb-small gw-text-[14px] gw-font-medium gw-text-text-secondary"
          >
            {{
              'features.withdrawals.modalPix.limits.sectionTitle' | translate
            }}
          </h3>
          <div
            class="gw-flex gw-flex-col gw-gap-medium gw-rounded-xl gw-bg-background-elevation-2 gw-p-medium"
          >
            <div
              class="gw-flex gw-items-center gw-justify-between gw-gap-small"
            >
              <span
                class="gw-text-[12px] gw-font-medium gw-text-text-secondary"
              >
                {{
                  'features.withdrawals.modalPix.limits.perTransaction'
                    | translate
                }}
              </span>
              <span
                class="gw-text-[14px] gw-font-semibold gw-tabular-nums gw-text-text-primary"
              >
                {{ hubTransactionLimitDisplay }}
              </span>
            </div>

            <div class="gw-flex gw-flex-col gw-gap-2x-small">
              <div
                class="gw-flex gw-items-center gw-justify-between gw-gap-small"
              >
                <span
                  class="gw-text-[12px] gw-font-medium gw-text-text-secondary"
                >
                  {{
                    'features.withdrawals.modalPix.limits.availableToday'
                      | translate
                  }}
                </span>
                <span
                  class="gw-text-[14px] gw-font-semibold gw-tabular-nums gw-text-text-primary"
                >
                  {{ hubDailyRemainingDisplay }}
                </span>
              </div>

              <ng-container *ngIf="hubShowDailyProgress">
                <div
                  class="gw-h-2 gw-w-full gw-overflow-hidden gw-rounded-full gw-bg-background-elevation-3"
                  role="progressbar"
                  [attr.aria-valuenow]="hubDailyUsagePercent"
                  aria-valuemin="0"
                  aria-valuemax="100"
                >
                  <div
                    class="gw-h-full gw-rounded-full gw-bg-accent-primary gw-transition-all"
                    [style.width.%]="hubDailyUsagePercent"
                  ></div>
                </div>
                <div
                  class="gw-flex gw-items-center gw-justify-between gw-gap-small"
                >
                  <span class="gw-text-[11px] gw-text-text-tertiary">
                    {{
                      'features.withdrawals.modalPix.limits.usedToday'
                        | translate
                    }}:
                    {{ hubDailyUsedDisplay }}
                  </span>
                  <span class="gw-text-[11px] gw-text-text-tertiary">
                    {{
                      'features.withdrawals.modalPix.limits.dailyCap'
                        | translate
                    }}:
                    {{ hubDailyCapDisplay }}
                  </span>
                </div>
              </ng-container>
            </div>
          </div>
        </section>

        <div class="gw-mb-0 gw-mt-x-large border-pix">
          <div class="gw-mt-x-large">
            <span class="gw-text-text-secondary gw-text-[14px] gw-font-medium">
              {{
                'features.withdrawals.modalPix.preferences.title' | translate
              }}
            </span>
            <div
              class="gw-flex gw-mt-x-large gw-w-full gw-items-center gw-justify-between gw-opacity-50 gw-pointer-events-none"
              *ngIf="false"
            >
              <span class="gw-text-text-primary gw-text-[14px] gw-font-medium">
                {{
                  'features.withdrawals.modalPix.preferences.pixAutomatic'
                    | translate
                }}
              </span>
              <span
                class="gw-text-text-tertiary gw-text-[12px] gw-font-medium"
                >{{
                  'features.withdrawals.modalPix.preferences.comingSoon'
                    | translate
                }}</span
              >
            </div>
            <button
              type="button"
              class="gw-flex gw-p-0 gw-w-full gw-items-center gw-justify-between gw-mt-small gw-border-0 gw-bg-transparent gw-cursor-pointer gw-text-left"
              (click)="navigateTo('/panel/recipients/pix-keys')"
            >
              <span class="gw-text-text-primary gw-text-[14px] gw-font-medium">
                {{
                  'features.withdrawals.modalPix.preferences.registerKeys'
                    | translate
                }}
              </span>
              <gatewee-icon
                icon="@phi.caret-right"
                iconStyle="primary"
                class="ph-bold"
                size="16px"
              ></gatewee-icon>
            </button>
          </div>

          <div class="gw-mt-2x-large">
            <span class="gw-text-text-secondary gw-text-[14px] gw-font-medium">
              {{
                'features.withdrawals.modalPix.otherServices.title' | translate
              }}
            </span>
            <button
              type="button"
              class="gw-flex gw-p-0 gw-w-full gw-items-center gw-justify-between gw-cursor-pointer gw-mt-small gw-border-0 gw-bg-transparent gw-text-left"
              (click)="navigateTo('/panel/chargebacks')"
            >
              <span class="gw-text-text-primary gw-text-[14px] gw-font-medium">
                {{
                  'features.withdrawals.modalPix.otherServices.chargebacks'
                    | translate
                }}
              </span>
              <gatewee-icon
                icon="@phi.caret-right"
                iconStyle="primary"
                class="ph-bold"
                size="16px"
              ></gatewee-icon>
            </button>
          </div>
        </div>
      </div>
      <div
        class="gw-min-w-0 gw-box-border pix-step-pane"
        [class.gw-flex]="usePageDrawer"
        [class.gw-min-h-0]="usePageDrawer"
        [class.gw-flex-1]="usePageDrawer"
        [class.gw-flex-col]="usePageDrawer"
        [class.pix-step-pane--visible]="activeFlow === 'transfer'"
      >
        <app-withdrawal-transfer-form
          #transferForm
          [flowActive]="activeFlow === 'transfer'"
          [pixShellKind]="usePageDrawer ? 'pageDrawer' : 'dialog'"
          [skipPixRecipientVerification]="skipPixRecipientVerification"
          [feeSnapshot]="feeSnapshot"
          (completed)="onTransferCompleted()"
          (emvHandoffBack)="onEmvHandoffBack()"
          (embeddedTitleKeyChange)="onTransferShellChange()"
          (shellFooterChange)="onTransferShellChange()"
        ></app-withdrawal-transfer-form>
      </div>
      <div
        class="gw-min-w-0 gw-box-border pix-step-pane"
        [class.gw-flex]="usePageDrawer"
        [class.gw-min-h-0]="usePageDrawer"
        [class.gw-flex-1]="usePageDrawer"
        [class.gw-flex-col]="usePageDrawer"
        [class.pix-step-pane--visible]="activeFlow === 'qrScanner'"
      >
        <app-qr-scanner-pane
          #qrScannerRef
          [active]="activeFlow === 'qrScanner'"
          (qrDetected)="onQrDetected($event)"
        ></app-qr-scanner-pane>
      </div>
      <div
        class="gw-min-w-0 gw-box-border pix-step-pane"
        [class.gw-flex]="usePageDrawer"
        [class.gw-min-h-0]="usePageDrawer"
        [class.gw-flex-1]="usePageDrawer"
        [class.gw-flex-col]="usePageDrawer"
        [class.pix-step-pane--visible]="activeFlow === 'emv'"
      >
        <app-withdrawal-emv-form
          #emvFormRef
          [pixShellKind]="usePageDrawer ? 'pageDrawer' : 'dialog'"
          [feeSnapshot]="feeSnapshot"
          (backRequested)="onEmvBack()"
          (continueRequested)="onEmvContinue()"
        ></app-withdrawal-emv-form>
      </div>
    </div>
  </div>
</ng-template>
